import { gql } from "@apollo/client";
export const createData = gql`
  mutation CreateRegisterJob($data: RegisterJobInput!) {
    createRegisterJob(data: $data) {
      status
    }
  }
`;
